// Restricted node palette for the Enrollment scenario editor.
// Only data-collection nodes (input / single / multi / date / time) and the
// two flow-control nodes (if:condition / goto) are available here.
export const nodeItemsConfig = [
  {
    title: "Messages",
    items: [
      {
        title: "Text input",
        titleDescription: "Send message",
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M3.5 4H12.5" stroke="#151515" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 14V4" stroke="#151515" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `,
        type: "GenericNode",
        nodeType: "message:input",
      },
      {
        title: "Single Choice",
        titleDescription: "Send message",
        type: "GenericNode",
        nodeType: "message:single",
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_5200_13580)">
              <path d="M8 16C12.1421 16 15.5 12.6421 15.5 8.5C15.5 4.35786 12.1421 1 8 1C3.85786 1 0.5 4.35786 0.5 8.5C0.5 12.6421 3.85786 16 8 16Z" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 12C9.933 12 11.5 10.433 11.5 8.5C11.5 6.567 9.933 5 8 5C6.067 5 4.5 6.567 4.5 8.5C4.5 10.433 6.067 12 8 12Z" fill="#151515"/>
              <path d="M8 12C9.933 12 11.5 10.433 11.5 8.5C11.5 6.567 9.933 5 8 5C6.067 5 4.5 6.567 4.5 8.5C4.5 10.433 6.067 12 8 12Z" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_5200_13580">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
            </defs>
          </svg>
        `,
      },
      {
        title: "Multiple Choice",
        titleDescription: "Send message",
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clip-path="url(#clip0_6667_12239)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1213 2.37868C14.4633 2.72063 14.7213 3.30067 14.86 4.51708C14.9984 5.73148 15 7.37049 15 9.67157C15 11.199 14.9969 12.2253 14.8667 13.0203C14.7456 13.7598 14.5256 14.217 14.1213 14.6213C13.7523 14.9903 13.2342 15.2309 12.2558 15.3625C11.2487 15.4979 9.91389 15.5 8 15.5C6.08611 15.5 4.75129 15.4979 3.74416 15.3625C2.76579 15.2309 2.2477 14.9903 1.87868 14.6213C1.50966 14.2523 1.26907 13.7342 1.13753 12.7558C1.00212 11.7487 1 10.4139 1 8.5C1 6.58611 1.00212 5.25129 1.13753 4.24416C1.26907 3.26579 1.50966 2.7477 1.87868 2.37868C2.2477 2.00966 2.76579 1.76907 3.74416 1.63753C4.75129 1.50212 6.08611 1.5 8 1.5C9.91389 1.5 11.2487 1.50212 12.2558 1.63753C13.2342 1.76907 13.7523 2.00966 14.1213 2.37868ZM14.8284 1.67157C16 2.84315 16 5.11929 16 9.67157C16 12.6618 16 14.1569 14.8284 15.3284C13.6569 16.5 11.7712 16.5 8 16.5C4.22876 16.5 2.34315 16.5 1.17157 15.3284C0 14.1569 0 12.2712 0 8.5C0 4.72876 0 2.84315 1.17157 1.67157C2.34315 0.5 4.22876 0.5 8 0.5C11.7712 0.5 13.6569 0.5 14.8284 1.67157ZM11.5172 7.0431C11.8172 6.75744 11.8288 6.28271 11.5431 5.98276C11.2574 5.68281 10.7827 5.67123 10.4828 5.9569L6.8 9.46429L5.51724 8.24261C5.21729 7.95695 4.74256 7.96853 4.4569 8.26847C4.17123 8.56842 4.18281 9.04315 4.48276 9.32882L6.28276 11.0431C6.57241 11.319 7.02759 11.319 7.31724 11.0431L11.5172 7.0431Z" fill="#151515"/>
            </g>
            <defs>
              <clipPath id="clip0_6667_12239">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
            </defs>
          </svg>
        `,
        type: "GenericNode",
        nodeType: "message:multi",
      },
      {
        title: "Date",
        titleDescription: "Send message",
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.25 2C5.25 1.58579 4.91421 1.25 4.5 1.25C4.08579 1.25 3.75 1.58579 3.75 2V3.02622C2.34577 3.08454 1.48481 3.27255 0.87868 3.87868C0 4.75736 0 6.17157 0 9V9.78946C0 12.6179 0 14.0321 0.87868 14.9108C1.75736 15.7895 3.17157 15.7895 6 15.7895H10C12.8284 15.7895 14.2426 15.7895 15.1213 14.9108C16 14.0321 16 12.6179 16 9.78947V8.99989C16 6.17154 16 4.75736 15.1213 3.87868C14.5152 3.27255 13.6542 3.08454 12.25 3.02622V2C12.25 1.58579 11.9142 1.25 11.5 1.25C11.0858 1.25 10.75 1.58579 10.75 2V3.0007C10.5117 3 10.2619 3 10 3H8H6C5.73811 3 5.48834 3 5.25 3.0007V2ZM10.75 4.65068V4.0008C10.5147 4.00007 10.2651 4 10 4H8H6C5.73486 4 5.48531 4.00007 5.25 4.0008V4.65068C5.25 5.0649 4.91421 5.40068 4.5 5.40068C4.08579 5.40068 3.75 5.0649 3.75 4.65068V4.02699C3.40777 4.0419 3.10834 4.06503 2.84143 4.10092C2.13538 4.19584 1.80836 4.36322 1.58579 4.58579C1.36322 4.80836 1.19584 5.13538 1.10092 5.84143C1.07618 6.0254 1.05751 6.22482 1.04341 6.44305H14.9566C14.9425 6.22481 14.9238 6.02538 14.8991 5.84141C14.8042 5.13538 14.6368 4.80836 14.4142 4.58579C14.1916 4.36322 13.8646 4.19584 13.1586 4.10092C12.8917 4.06503 12.5922 4.0419 12.25 4.02699V4.65068C12.25 5.0649 11.9142 5.40068 11.5 5.40068C11.0858 5.40068 10.75 5.0649 10.75 4.65068ZM14.9924 7.44305H1.00759C1.00036 7.89433 1 8.40837 1 9V9.78946C1 11.2319 1.00212 12.2132 1.10092 12.948C1.19584 13.6541 1.36322 13.9811 1.58579 14.2037C1.80836 14.4262 2.13538 14.5936 2.84143 14.6885C3.57625 14.7873 4.55752 14.7895 6 14.7895H10C11.4425 14.7895 12.4237 14.7873 13.1586 14.6885C13.8646 14.5936 14.1916 14.4262 14.4142 14.2037C14.6368 13.9811 14.8042 13.6541 14.8991 12.948C14.9979 12.2132 15 11.2319 15 9.78947V8.99989C15 8.40831 14.9996 7.8943 14.9924 7.44305Z" fill="#151515"/>
          </svg>
        `,
        type: "GenericNode",
        nodeType: "message:date",
      },
      {
        title: "Time",
        titleDescription: "Send message",
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.25C4.27208 1.25 1.25 4.27208 1.25 8C1.25 11.7279 4.27208 14.75 8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25ZM0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8 3.25C8.41421 3.25 8.75 3.58579 8.75 4V7.68934L10.7803 9.71967C11.0732 10.0126 11.0732 10.4874 10.7803 10.7803C10.4874 11.0732 10.0126 11.0732 9.71967 10.7803L7.46967 8.53033C7.32902 8.38968 7.25 8.19891 7.25 8V4C7.25 3.58579 7.58579 3.25 8 3.25Z" fill="#151515"/>
          </svg>
        `,
        type: "GenericNode",
        nodeType: "message:time",
      },
    ],
  },
  {
    title: "Logic",
    items: [
      {
        title: "If Condition",
        icon: `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_5200_13614)">
              <path d="M0.5 6V1H5.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M15.5 6V1H10.5" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M0.5 1L7.5 8V16" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M15.5 1L9.5 7" stroke="#151515" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_5200_13614">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
              </clipPath>
            </defs>
          </svg>
        `,
        type: "IfConditionNode",
        nodeType: "if:condition",
        bgColor: "hsla(240, 12%, 48%, 0.08)",
      },
      {
        title: "Goto",
        titleDescription: "Go to another message",
        icon: `
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 6.75482L8 8.75482L6 10.7548" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 6.75482L12 8.75482L10 10.7548" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.96527 13.9196C2.16663 12.9846 2.16663 11.5746 2.16663 8.75484C2.16663 5.93502 2.16663 4.52511 2.96527 3.59002C3.07868 3.45723 3.20235 3.33356 3.33513 3.22016C4.27023 2.42151 5.68014 2.42151 8.49996 2.42151C11.3198 2.42151 12.7297 2.42151 13.6648 3.22016C13.7976 3.33356 13.9212 3.45723 14.0346 3.59002C14.8333 4.52511 14.8333 5.93502 14.8333 8.75484C14.8333 11.5746 14.8333 12.9846 14.0346 13.9196C13.9212 14.0524 13.7976 14.1761 13.6648 14.2895C12.7297 15.0882 11.3198 15.0882 8.49996 15.0882C5.68014 15.0882 4.27023 15.0882 3.33513 14.2895C3.20235 14.1761 3.07868 14.0524 2.96527 13.9196Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `,
        type: "GenericNode",
        nodeType: "message:goto",
        bgColor: "hsla(240, 12%, 48%, 0.08)",
      },
    ],
  },
];
